import { render, staticRenderFns } from "./RunVersionDetailPanel.vue?vue&type=template&id=2c5f0581&scoped=true"
import script from "./RunVersionDetailPanel.vue?vue&type=script&lang=js"
export * from "./RunVersionDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./RunVersionDetailPanel.vue?vue&type=style&index=0&id=2c5f0581&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5f0581",
  null
  
)

export default component.exports